import React, { useState, useEffect } from "react";
import { Search } from "react-bootstrap-icons";
import { BiEditAlt } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import {RiDeleteBin5Line} from "react-icons/ri"
import { Table } from "reactstrap";
import { FaArrowRight,FaMapMarkerAlt } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
// CSS....
import "../../styles/Tours/booking.css";
import Layout from "../../components/Layout";
import { Modal, ModalHeader, ModalBody, ModalFooter,Badge } from "reactstrap";
import SearchableDropdown from "../../searchableDropdown";

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import UpdateTime from "../Admin/UpdateTime";
import Select from "react-select";
import axios from "axios";
import FareEditModal from "../../FareEditModal";
import WaitingChargeEditModal from "../../WaitingChargeEditModal";
import PaymentTypeEditModal from "../../PaymentTypeEditModal";
import moment from "moment";
import TimeEditModal from "../../TimeEditModal";
import { CSVLink } from "react-csv";
import ReactSelect from "../../ReactSelect";
import { baseUrl } from "../../api/apiConfig";
import BookingsEditModal from "../../components/editModals/BookingsEditModal";
import Pagination from "../../Pagination";
import VegamEditModal from "../../VegamEditModal";
import Tourss from "./Tourss";
import Menus from "../counts/Menus";
import DCEditModal from "../../components/editModals/DCEditModal";
import { useNavigate } from "react-router-dom";
// lodash....
import {debounce} from "lodash"

import {getBookingsData} from "../../store/bookings/action"
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const hasActiveDriverAssignment = (booking) =>
  Boolean(
    booking?.tour_id ||
    booking?.assigned_vehicle_id ||
    Number(booking?.assign_tour_status) === 1,
  );

const Bookings = () => {
  // const dispatch=useDispatch()
  // const {bookings,bookingsCount}=useSelector((state)=>state.bookingsReducer)
  // console.log(bookings,"--from Redux")
  const navigate=useNavigate()
  const [bookData, setBookData] = useState([]);
  const [loading,setLoading]=useState(false)
  const[error,setError]=useState("")
  const [locationData, setLocationData] = useState([]);
  const [location,setLocation]=useState("")
  const [summ, setSumm] = useState(false);
  const [summ1, setSumm1] = useState(false);
  const [bookCsv, setBookCsv] = useState(false);
  const [bookdata, setBookdata] = useState(false);

  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [summ_date, setSumm_date] = useState(null);
  const [csvDate, setCsvDate] = useState(null);
  const [csvDate1, setCsvDate1] = useState(null);
  const [bookingDate, setBookingDate] = useState(null);
  const [bookingDate1, setBookingDate1] = useState(null);
  

  // Modal date- state
  const [bookingDate2, setBookingDate2] = useState(null);
  const [editTime, setEditTime] = useState(false);
  const [editPayment, setEditPayment] = useState(false);
  const [editfare, setEditfare] = useState(false);
  const [waitingCharges, setWaitingCharges] = useState(false);
  const [dcNumber,setDcNumber] = useState(false);
  //
  const[obj,setObj]=useState({})
  // FOR TBE & SPLIT
    const [disable,setDisable] = useState(false);
    const [declineBtn,setDeclineBtn]=useState(true)
    const [splitdisable,setSplitDisable] = useState(false);
    const[tripId,setTripId]=useState("")
    const[bookingAction,setBookingAction]=useState({value:"TBE"})  
    const[splitOption,setSplitOption]=useState({value:"no split"})  
    const[bookingId,setBookingId]=useState(0)
    const[fare,setFare]=useState(0) 
    //  FARE and DECLINE MODAL
    const[fareModal,setFareModal]=useState(false)
    const[tripDeclineModal,settripDeclineModal]=useState(false)
    const[splitModal,setSplitModal]=useState(false)
    const[dateMessage,setDateMessage]=useState(false)
    const[summaryDownloadBtn,setSummaryDownloadBtn]=useState(false)
    const[errorMessage,setErrorMessage]=useState(false)
    const[url,setUrl]=useState(null)
    const[reportCsv,setReportCsv]=useState(null)
    const[trackReport,setTrackReport]=useState([])
    const[customerList,setCustomerList]=useState([])
    const[value,setValue]=useState(null)
    const[customerId,setCustomerId]=useState(null)
    const[isClearable,setIsClearable]=useState(true)
    const[bookingReport,setBookingReport]=useState([])
    // Filter ...
    const[statusPayload,setStatusPayload]=useState({
      booking_status:localStorage.getItem("bookingStatus")?localStorage.getItem("bookingStatus"):"",
      booking_type:localStorage.getItem("booking_type")?localStorage.getItem("booking_type"):"",
      customer_id:localStorage.getItem("customerId")?localStorage.getItem("customerId"):"",
      driver_name:localStorage.getItem("driverId")?localStorage.getItem("driverId"):"",
      id:localStorage.getItem("bookingId")?localStorage.getItem("bookingId"):"",
      limit:10,
      offset:0,
      status:localStorage.getItem("status")?localStorage.getItem("status"):""

    })
    const[deleteModal,setDeleteModal]=useState(false)
    const[deleteId,setDeleteId]=useState(null)
    const[filterCusList,setFilterCusList]=useState([])
    const[driversList,setDriversList]=useState([])
    const[filterDriverList,setFilterDriverList]=useState([])
    const[customerName,setCustomerName]=useState("")
    const[driverName,setDriverName]=useState("")
    const [edit, setEdit] = useState(false);
    const[editData,setEditData]=useState(null)
    const[pageNumber,setPageNumber]=useState(0)
    const [inputPageNumber, setInputPageNumber] = useState(''); 
    const[totalCount,setTotalCount]=useState(0) 
    const[pagedataCount,setPageDataCount]=useState(10)    
    const [isVegamEdit, setIsVegamEdit] = useState(false);
    const[loadingMsg,setLoadingMsg]=useState(false)
    const[indexNo,setIndexNo]=useState()
    const[tripId2,setTripId2]=useState()
    const[search,setSearch]=useState("")
    const[notificationShow,setNotificationShow]=useState(false)
    const[currentDateTime,SetCurrentDateTime]=useState(new Date())
    const [ondcSelection,setOndcSelection]=useState(false)


    // For Bookings Edit Modal..
    const handleEdit = (item) => {
      setEdit(!edit);
      setEditData(item)
    };
    const handleVegam = () => {
      setIsVegamEdit(!isVegamEdit)
    }


    const openDeleteModal=(id)=>{
      setDeleteModal(!deleteModal)
      setDeleteId(id)
    }

    // Delete Bookings ..

    const deleteBooking=async()=>{
    try {
      const resp=await axios.post(`${baseUrl}/booking/deleteBooking/${deleteId}`)
      if(resp.data.success){
        alert(resp.data.message)
        getTodayBookings()
        setDeleteModal(false)
      }
      
    } catch (error) {
      console.log(error,"Failed to Delete ?");
      
    }
    }


    






    const filterByStatus=async()=>{
      try {
        setLoading(true)
        const resp=await axios.post(`${baseUrl}/booking/getTodayBookings`,{
          ...statusPayload,limit:showDataPerPage,offset:offset
        });
        console.log("response",resp);
        if(resp.data.success){
          const data=resp.data.data.bookings;
          setBookData(data)
          setTotalCount(resp.data.data.count)
          setPageNumber(0)
        }
        
      } catch (error) {
        console.log(error,"Failed to filter ");
        console.error(error);
        
      }finally{
        setLoading(false)

      }

    }





// Clear Filter status ,,,
    const resetField=()=>{
      window.location.reload();
      localStorage.removeItem("status")
      localStorage.removeItem("bookingId")
      localStorage.removeItem("customerId")
      localStorage.removeItem("driverId")
      localStorage.removeItem("customerObj")
      localStorage.removeItem("driverObj")
      localStorage.removeItem("bookingStatus")
      localStorage.removeItem("booking_type")

      
    }

    const getAllCustomersForFilter=async()=>{
      try {
            const request=await axios.post(`${baseUrl}/users/getAllCustomers`,{limit:600,offset:0})
          if(request.data.success){
            const result=request.data.data.customers
            const filterData=result.map((elem)=>({
              label:`${elem.name}`,
              value:`${elem.id}`
            }))
            setFilterCusList(filterData)
          }else{
  
          }
      } catch (error) {
        console.log(error);
        
      }
      
    }

    const getAllDriversForFilter=async()=>{
        try {
          const resp=await axios.post(`${baseUrl}/driver/getDrivers`,{limit:100,offset:0})
          if(resp.data.success){
            const data=resp.data.data.drivers;
            setDriversList(data)
            const reData=data.map((elem,index)=>({label:elem.name,value:elem.name}))
            setFilterDriverList(reData)
          }
          
        } catch (error) {
          console.log(error);
          
        }     
    }
    console.log("getAllDriversForFilter..",filterDriverList)

    const getcustomerId=(selected)=>{
      setCustomerName(selected)
      setStatusPayload({...statusPayload,customer_id:selected.value})
      localStorage.setItem("customerId",selected.value)
      localStorage.setItem("customerObj",JSON.stringify(selected))
    }

    const getDriverName=(selected)=>{
      console.log(selected)
      setDriverName(selected)
      setStatusPayload({...statusPayload,driver_name:selected.value})
      localStorage.setItem("driverId",selected.value)
      localStorage.setItem("driverObj",JSON.stringify(selected))
    }

    // useEffect(()=>{
    //   getAllCustomersForFilter()
    //   getAllDriversForFilter()
    // },[])

    
  
    
    const handleFareModal_state=()=>{
        setFareModal(!fareModal)
    }
    const handleDeclineModal_state=()=>{
        settripDeclineModal(!tripDeclineModal)
    }
    const handlesplitModal=()=>{
        setSplitModal(!splitModal)
    }

  const handleBookingAction=(event,id)=>{
    setBookingId(id)
    setBookingAction({value:event.target.value})
    setFareModal(true)
    settripDeclineModal(true)
  }

  const handleSplitOption=(event)=>{
    setSplitOption({value:event.target.value})
    setSplitModal(true)

  }
  console.log(splitOption);
  console.log("Bookingid :",bookingId)

  // pagination ..
  const showDataPerPage = pagedataCount;
  const offset = pageNumber * showDataPerPage;
  const pageCount = Math.ceil(totalCount / showDataPerPage);

  // bookingsCount have to replace totalCount

  const outputNumber = totalCount; // Dynamic input number
  const result = [];
  
  if (outputNumber < 10) {
    result.push(10); // Push 10 if the outputNumber is less than 10
  } else {
    let nextMultipleOfTen = Math.ceil(outputNumber / 10) * 10; // Round up to the next multiple of 10
    for (let i = 10; i <= nextMultipleOfTen; i += 10) {
      result.push(i); // Push multiples of 10 up to the next multiple of 10
    }
  }
  
  console.log(result,"result");

  
  const handlePageNumber=(e)=>{
    setInputPageNumber(e.target.value)
    if( e.target.value == ""){
        console.log("no page no")
        setPageNumber(0)
    }
}

console.log(pageNumber)
    const handleGoToPage = () => {
    const pageNumber = parseInt(inputPageNumber);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= pageCount) {
        setPageNumber(pageNumber - 1); // Page numbers start from 1, but indexes start from 0
    } else {
      console.error('Invalid page number');
    }

    };

  const handlePageChange=({selected})=>{
      setPageNumber(selected)
  }

  const tripCancellation=async(bookingId)=>{
    console.log("poo - ",bookingId);
    setTripId(bookingId)
    try {
        const response=await axios.post(`${baseUrl}/booking/cancelByManager`,{"booking_id":bookingId},
        {headers:{"Content-Type":"application/json"}})
        console.log("Trip cancellation",response);
        if(response.data.success === true){
            alert(response.data.message)
            settripDeclineModal(false)
            getTodayBookings(statusPayload)
        }
        
    } catch (error) {
        console.log(error.message);
        alert("Failed Cancellation")
        
    }
  }

  

  const submitFare=async ()=>{
    console.log(bookingId,"From Suubmit fare Button");
    try {
        const response=await axios.post(`${baseUrl}/booking/acceptBooking`,
        {"booking_id":bookingId,fare:fare},{
        headers:{"Content-Type":"application/json"}
        })
        if(response.data.success === true){
          getTodayBookings()
            alert("Fare sent Successfully.");
            setFareModal(false)
            
        }
    } catch (error) {
        console.log(error.message);
        alert("sending Fare Failed !")
        
    }
    
  }



  // TBE button function...

  const handletbeConfirmation = async (booking_id) => {
    const result=await axios.post(`${baseUrl}/booking/tbeBooking`,{"booking_id":booking_id},{
        headers:{"Content_type":"application/json"}
    })
    if(result.data.success){
      getTodayBookings()
    }else{
        console.log("something went Wrong");
    }

  };

  const handleConfirmation = async (booking_id) => {
    console.log(booking_id);
    const result=await axios.post(`${baseUrl}/booking/confirmBooking`,{"booking_id":booking_id},{
        headers:{"Content_type":"application/json"}
    })
    console.log(result,"from Tbe");
    console.log(result.data.success);
    if(result.data.success){
      getTodayBookings()
    }else{
        console.log("something went Wrong");
    }
  };
  

  // BY Split and No split....

  const handleSplitConfirmation = async (item,tripId,index) => {
    setIndexNo(index)
    console.log("trip id...", tripId,index);
    console.log(item.id);
    
    
    
    const result=await axios.post(`${baseUrl}/booking/markTrip`,{
    booking_id:tripId});
    console.log(result,"from split");
    if(result.data.success){
      getTodayBookings(statusPayload)
    }else{
        console.log("something Wrong Check");
    }

  };

  const summary = () => {
    setSumm(!summ);
    setDateMessage(false)
    setSummaryDownloadBtn(false)
    setStartDate(null)
    setEndDate(null)
    setErrorMessage(false)
  };
  const summary1 = () => {
    setSumm1(!summ1);
    setSumm_date(null)
    setSummaryDownloadBtn(false)
    setErrorMessage(false)
    setDateMessage(false)
  };
  const bookingCSV = () => {
    setBookCsv(!bookCsv);
    setCsvDate(null)
    setCsvDate1(null)
    setSummaryDownloadBtn(false)
    setErrorMessage(false)
    setDateMessage(false)
  };
  const bookingdata = () => {
    setBookdata(!bookdata);
    setBookingDate(null)
    setBookingDate1(null)
    setSummaryDownloadBtn(false)
    setValue(null)
    setDateMessage(false)
    setErrorMessage(false)
  };
  
  

  // API CALL GET TODAY BOOKINGS DATA...
  const fakedata = {
    pickup_location:
      "#02 Parthasarathypuram 2nd street, Tnagar,chennai District,Tamil Nadu, 600017, India",
    pickup_time: "2023-10-17 05:10:00",
    dropoff_location:
      "KFC, Near Vavin, 1, 1C, Kambar St, Reddipalaiyam, Mogappair, Chennai, Tamil Nadu 600037, India",
    dropoff_time: "2023-10-18 04:00:00",
    commodity_weight: 555,
    receiver_name: "venkatachalam",
    receiver_contact: "8778620133",
    pickup_lat: 13.0405026,
    pickup_long: 80.2336924,
    dropoff_lat: 13.084683,
    dropoff_long: 80.16985,
  };


    useEffect(()=>{
      const intervalId=setInterval(()=>{
        SetCurrentDateTime(new Date())
      },300000) // 10 mins Once update the current date and Time

      return ()=>clearInterval(intervalId)

    },[])

    

  const getTodayBookings = async () => {
    try {
      setLoading(true);
      const request = await axios.post(`${baseUrl}/booking/getTodayBookings`, {
        ...statusPayload,
        limit: showDataPerPage,
        offset: offset,
      });
      const data = request.data.data.bookings;
      
      // Notication Added
      let notification = false;
      let waiting_time=""
      let point=""
      const processedData = data.map((booking) => {
        if (booking.reached_pickup && booking.completed_pickup == null) {
          const reachedPickup = new Date(booking.reached_pickup);
          const reachedPickupPlus15 = new Date(reachedPickup);
          reachedPickupPlus15.setMinutes(reachedPickup.getMinutes() + 30);
          if (currentDateTime > reachedPickupPlus15) {
            const date1=moment(currentDateTime,"ddd MMM DD YYYY HH:mm:ss ZZ")
            const date2=moment(reachedPickup,"ddd MMM DD YYYY HH:mm:ss ZZ")
            const diffInMis=(date2-date1)/(1000*60)
            notification = true;
            const hours = Math.floor(diffInMis / 60);
            const minutes = diffInMis % 60;
            const diffinSecs=date1.diff(date2)
            const duration=moment.duration(diffinSecs)
            const hrs=Math.floor(duration.asHours())
            const mins=duration.minutes()
            const secs=duration.seconds()

            // waiting_time=Math.floor(minutes)
            waiting_time=`${hrs} hr ${mins} mins ${secs} sec`
            point="Pickup"
             
          }
          

        } else if (booking.reached_pickup && booking.completed_pickup && booking.reached_drop == null && booking.completed_drop == null) {
          notification = false;
          waiting_time=""
          point=""
        } else if (booking.reached_pickup && booking.completed_pickup && booking.reached_drop && booking.completed_drop == null) {
          const reachedDrop = new Date(booking.reached_drop);
          const reachedDropPlus15 = new Date(reachedDrop);
          reachedDropPlus15.setMinutes(reachedDrop.getMinutes() + 30);
          if (currentDateTime > reachedDropPlus15) {
            notification = true;
            // const date1=new Date(reachedDrop)
            // const date2=new Date(currentDateTime)
            // const diffInMis=(date2-date1)/(1000*60)
            // const hours = Math.floor(diffInMis / 60);
            // const minutes = diffInMis % 60;
            const date1=moment(currentDateTime,"ddd MMM DD YYYY HH:mm:ss ZZ")
            const date2=moment(reachedDrop,"ddd MMM DD YYYY HH:mm:ss ZZ")
            const diffinHrs=date1.diff(date2,'hours',true)
            const diffinMins=date1.diff(date2,'minutes')
            const diffinSecs=date1.diff(date2)
            const duration=moment.duration(diffinSecs)
            const hrs=Math.floor(duration.asHours())
            const mins=duration.minutes()
            const secs=duration.seconds()

            // waiting_time=Math.floor(minutes)
            waiting_time=`${hrs} hr ${mins} mins ${secs} secs`
            point="Drop"
          } else {
            notification = false;
            waiting_time=""
            point=""
          }
        } else if(booking.reached_pickup && booking.completed_pickup && booking.reached_drop && booking.completed_drop){
          notification=false;
          waiting_time=""
          point=""
        } else {
          notification = false;
          waiting_time=""
          point=""
        }

        return { ...booking, notification ,waiting_time,point};
      });
      console.log(processedData,"processedData")
      setBookData(processedData);
      // setBookData(data);
      setTotalCount(request.data.data.count);
      
    } catch (error) {
      console.error("Error fetching today's bookings:", error);
      setError(error.message)
    } finally {
      setLoading(false);
    }
  };
  



 

  const handleNotificationClose=(id)=>{
    const updatedData=bookData.map((booking)=>{
      if(booking.id == id){
        return{
          ...booking,
          notification:false,
          point:"",
          waiting_time:""
        }
      }
      return booking
    })
    setBookData(updatedData)
  }



  // DELETE & EDIT- CHECKING FUNCTION..
  
 
  const handleChangeEditTime = () => {
    setEditTime(!editTime);
  };
  
  const handleEditPayment = () => {
    setEditPayment(!editPayment);
  };
  const handleEditFare = () => {
    setEditfare(!editfare);
    
  };

const getObj=(obj)=>{
    setObj(obj);
}

  const handle_waitingCharges = () => {
    setWaitingCharges(!waitingCharges);
  };

  // All Download Btns fn...

  // 1.Daily Summary Btn..

  const getDailySummaryReport = async () => {
  setLoadingMsg(true);
  setErrorMessage(false); // Reset error state

  const reportDate = moment(summ_date).format("YYYY-MM-DD");

  if (reportDate === "Invalid date") {
    setDateMessage(true);
    setLoadingMsg(false);
    return;
  }

  setDateMessage(false);

  try {
    const payload = { report_date: reportDate };
    const response = await axios.post(`${baseUrl}/location/daySummaryReports`, payload);

    if (response.data.success) {
      setSummaryDownloadBtn(true);
      setUrl(response.data.data.report);
    } else {
      setErrorMessage(true);
    }
  } catch (error) {
    console.error("Error fetching daily summary:", error);
    setErrorMessage(true);
  } finally {
    setLoadingMsg(false);
  }
};


  // 2.Tracking Records Btn..
  const getTrackingReports=async()=>{
    const payload={
      start_date:moment(startdate).format("YYYY-MM-DD"),
      end_date:moment(enddate).format("YYYY-MM-DD"),
      limit:1000
    }
    console.log(payload,"payload");
    if(payload.start_date =="Invalid date" || payload.end_date =="Invalid date" ){
      setDateMessage(true)
    }else{
      setDateMessage(false)
      try {
        const request=await axios.post(`${baseUrl}/booking/getBookingsReport`,payload)
        if(request.data.success){
          setSummaryDownloadBtn(true)
          const result=request.data.data.bookings
          setTrackReport(result)
        }
        else{
          setErrorMessage(true)

        }
        
      } catch (error) {
        console.log(error);
        
      }

    }
    
  }
  
  // 3. Export Booking csv Btn...
  const getBookingsReportCsv=async()=>{
    const payload={
      start_date:moment(csvDate).format("YYYY-MM-DD"),
      end_date:moment(csvDate1).format("YYYY-MM-DD"),
    }
    if(payload.start_date =="Invalid date" || payload.end_date =="Invalid date" ){
      setDateMessage(true)
    }else{
      setDateMessage(false)
      try {
         setLoadingMsg(true)
         let request;
         if(ondcSelection){
            request=await axios.post(`${baseUrl}/booking/exportONDCInvoiceBookingsCsv`,payload)
         }else{
           request=await axios.post(`${baseUrl}/booking/exportInvoiceBookingsCsv`,payload)
         }
          if(request.data.success){
            setSummaryDownloadBtn(true)
            const result=request.data.data
            setReportCsv(result)
            // alert(request.data.message)
            alert("Report Generated Successfully.")
          }
          else{
            setErrorMessage(true)

          }
      } catch (error) {
        console.log(error);
      }finally{
        setLoadingMsg(false)
      }

    }
    
  }

  // 4.Export Booking Data Button ..

  const getAllCustomers=async()=>{
    try {
          const request=await axios.post(`${baseUrl}/users/getAllCustomers`,{limit:600,offset:0})
        if(request.data.success){
          const result=request.data.data.customers
          const data=result.map((elem)=>({
            label:`${elem.name}-${elem.mobile}`,
            value:`${elem.id}`
          }))
          setCustomerList(data);
          const filterData=result.map((elem)=>({
            label:`${elem.name}`,
            value:`${elem.id}`
          }))
          setFilterCusList(filterData)
        }else{

        }
    } catch (error) {
      console.error(error,error.message)
      
    }
    
  }

  const handleSelectedOption=(selected)=>{
    setValue(selected)
    setCustomerId(selected.value)
  }

  const getBookingDataReport=async()=>{
    const payload={
      start_date:moment(bookingDate).format("YYYY-MM-DD"),
      end_date:moment(bookingDate1).format("YYYY-MM-DD"),
      customer_id:customerId,
      limit:5000
    }

    if(payload.start_date=="Invalid date"||payload.end_date=="Invalid date"||payload.customer_id==null){
      setDateMessage(true)

    }else{
      setDateMessage(false)
      try {
        const request=await axios.post(`${baseUrl}/booking/getBookingsDetails`,payload)
        console.log(request.data.success);
      if(request.data.success){
        const result=request.data.data.bookings;
        setBookingReport(result)
        setSummaryDownloadBtn(true)

      }else{
        setErrorMessage(true)

      }
      
    } catch (error) {
      console.log(error);
      
    }
    }
  }
  const handleDcNumber=()=>{
    setDcNumber(!dcNumber)
  }

  const getNotification=(bookings)=>{
      console.log(";;;;;")
  }
 


  useEffect(()=>{
    getAllCustomersForFilter()
    getAllDriversForFilter()
  },[])
  


 
  const pendingCreatedBookings = bookData.filter(item => item.status === "Pending" && item.booking_status === "Created");
  const confirmedConfirmedBookings = bookData.filter(item => item.status === "Confirmed" && item.booking_status === "Confirmed");
  const nonFilteredBookings = bookData.filter(item => !((item.status === "Pending" && item.booking_status === "Created") || (item.status === "Confirmed" && item.booking_status === "Confirmed")));
  const sortedBookings = [...confirmedConfirmedBookings, ...pendingCreatedBookings, ...nonFilteredBookings];

 

  useEffect(() => {

    getTodayBookings({...statusPayload,limit:showDataPerPage,offset:offset});
  }, [offset,currentDateTime,pagedataCount]);
  //currentDateTime 
  // pagedataCount,pageNumber,bookData?.length,

  const customOrder = ["Pending", "Confirmed", "Accepted", "Canceled By Manager"];
  
  const handleOndcSelection=(e)=>{
    // e.preventDefault()
    setOndcSelection(e.target.checked)
    setSummaryDownloadBtn(false)
  }
  console.log("ondcSelection..",ondcSelection)
  

  return (

    <div style={{ padding: "10px" }} id="bookingComp">
      <Menus bookingCount={totalCount}/>
      {/* <Menus bookingCount={totalCount}/> */}
      <section className="searchBar-section">
      
        <div className="session-Top-Input" style={{position:"relative"}}>
          <Search className="searchIcon" style={{position:"absolute",left:"285px"}} />
          <input
            type="text"
            placeholder="Search owner by name,phone or address"
            style={{ width: "310px",}}
            value={search}
            onChange={(e)=>setSearch(e.target.value.trim())}
          />
        </div>
        <div className="vehicle-btns">
          <button className="btn-big" onClick={summary}>
            Tracking Records
          </button>
          <button className="btn-big" onClick={summary1}>
            Daily Summary
          </button>
          <button className="btn-big" onClick={()=>{
            bookingdata()
            getAllCustomers()
          }}>
            Export Booking Data
          </button>
          <button className="btn-big" onClick={bookingCSV}>
            Export Booking CSV
          </button>
        </div>
      </section>
      {/* 1.Tracking Records Modal... */}

      <div className="records-modal">
        <Modal isOpen={summ} className="button-modals tracking-records">
          <ModalHeader toggle={summary} style={{ border: "none" }}>
            <span style={{ fontSize: "20px" }}>Filter</span>
          </ModalHeader>
          <ModalBody className="button-modals-body">
            <p>Period of Time :</p>
            <div className="dateBox">
              <div>
                <DatePicker
                  placeholderText="Start Date"
                  selected={startdate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                ></DatePicker>
              </div>
              <div>
                <DatePicker
                  placeholderText="End Date"
                  selected={enddate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                ></DatePicker>
              </div>
            </div>
            <div className="modalFilterBtn">
              <button className="btn-small" onClick={getTrackingReports}>Filter</button>
              { summaryDownloadBtn ? <CSVLink className="btn-small"
               data={trackReport}
               target="_blank"
               filename="Bookings Record.csv"
               >Download</CSVLink>:""}
              {dateMessage ? "Please Choose Date":""}
              {errorMessage ? "No Records are Found.":""}
            </div>
          </ModalBody>
        </Modal>
      </div>

      {/*2. Modal-Daily Summary */}

      <div className="summary-modal">
        <Modal isOpen={summ1} className="button-modals daily-summary">
          <ModalHeader toggle={summary1} style={{ border: "none" }}>
            <span style={{ fontSize: "20px" }}>Filter</span>
          </ModalHeader>
          <ModalBody className="button-modals-body">
            <p>Period of Time :</p>
            <div className="dateBox">
              <div>
                <DatePicker
                  placeholderText="Choose date"
                  selected={summ_date}
                  onChange={(date) => setSumm_date(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                ></DatePicker>
              </div>
            </div>
            <div className="modalFilterBtn">
              <button className="btn-small" onClick={getDailySummaryReport}>Filter</button>
              {summaryDownloadBtn ? <a href={url} target="_blank" className="btn-small">Download</a>:""}
              {dateMessage ? "Please Choose Date":""}
              {errorMessage ? "No Records are Found":""}
              {loadingMsg ? <span>Loading...</span>:"" }
            </div>
          </ModalBody>
        </Modal>
      </div>

      {/* 3.Export Booking Modal Data */}

      <div>
        <Modal isOpen={bookdata} className="button-modals export-booking-data">
          <ModalHeader style={{ border: "none" }} toggle={bookingdata}>
            <span style={{ fontSize: "20px" }}>Filter</span>
          </ModalHeader>
          <ModalBody className="button-modals-body">
            <p>Customer Name :</p>
            <div style={{width:"80%"}}>
              <ReactSelect
              value={value}
              isClearable={isClearable}
              // classNamePrefix="ppo"
              placeholder="Please choose customer"
              options={customerList}
              isMulti={false}
              handleSelectedOption={handleSelectedOption}
              />
              {/* <span style={{ color: "red" }}>Please Choose the customer !</span> */}
            </div>
            <p style={{ marginTop: "15px" }}>Period of time :</p>
            <div className="dateBox">
              <div>
                <DatePicker
                  selected={bookingDate}
                  onChange={(date) => setBookingDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                  placeholderText="Pickup Date From"
                ></DatePicker>
              </div>
              <div>
                <DatePicker
                  selected={bookingDate1}
                  onChange={(date) => setBookingDate1(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                  placeholderText="To"
                ></DatePicker>
              </div>
            </div>

            <div className="modalFilterBtn">
              <button className="btn-small" onClick={getBookingDataReport}>Filter</button>
              {summaryDownloadBtn && <CSVLink
              className="btn-small"
              filename="Bookings.csv"
              data={bookingReport}
              target="_blank"
              >Download</CSVLink>}
            {dateMessage ?"Please Fill the field":""}
            {errorMessage ? "No Records are Found.":""}
            </div>
          </ModalBody>
        </Modal>
      </div>
      {/* 4. Modal-Export Booking Csv */}

      <div className="bookCSV-modal">
        <Modal isOpen={bookCsv} className="button-modals export-booking-csv">
          <ModalHeader toggle={bookingCSV} style={{ border: "none" }}>
            <span style={{ fontSize: "20px" }}>Filter Data in CSV</span>
          </ModalHeader>
          <ModalBody className="button-modals-body">
            <p>Pickup Date :</p>
            <p>
              <div>
                <input type="checkbox" name="ondc" id="ondc" 
                checked={ondcSelection}
                onChange={handleOndcSelection}/> {""}
                <label htmlFor="ondc">Choose for ONDC report ?</label>
              </div>
            </p>
            <div className="dateBox">
              <div>
                <DatePicker
                  selected={csvDate}
                  onChange={(date) => setCsvDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                  placeholderText="From"
                ></DatePicker>
              </div>
              <div>
                <DatePicker
                  selected={csvDate1}
                  onChange={(date) => setCsvDate1(date)}
                  dateFormat="yyyy-MM-dd"
                  className="datePicker"
                  placeholderText="To"
                ></DatePicker>
              </div>
            </div>
            <div className="modalFilterBtn">
              <button className="btn-small" onClick={getBookingsReportCsv}>Filter</button>
              { summaryDownloadBtn ? <a href={reportCsv} filename="Bookings Csv"  className="btn-small">Download</a>:""}
              {dateMessage ? "Please Choose Date":""}
              {errorMessage ? "No Records are Found.":""}
              {loadingMsg ? <span>Loading...</span>:""  }
            </div>
          </ModalBody>
        </Modal>
      </div>

      

      <BookingsEditModal
      isOpen={edit}
      toggle={handleEdit}
      editData={editData}
      getTodayBookings={getTodayBookings}
      />



      {
        (bookingAction.value ==="TBE") ? ("")
        :bookingAction.value === "Fare"?(<div id="FareModal">
            <Modal isOpen={fareModal} id="FareModal-mobile">
                <ModalHeader 
                className="modal-header"
                style={{ border: "none" }}
                toggle={handleFareModal_state}>Enter Fare :</ModalHeader>
                <ModalBody>
                <div className="fare-modal-body">
                <input
                    type="number"
                    min="0"
                    placeholder="Enter Your Fare"
                    value={fare}
                    onChange={(event)=>setFare(event.target.value)}
                />
                <div>
                    <button onClick={submitFare}>confirm</button>
                </div>
                </div>
                </ModalBody>
            </Modal>
        </div>)
        :bookingAction.value === "Decline"?(
            <div id="TripDeclineModal">
                <Modal isOpen={tripDeclineModal} id="TripDeclineModal-mobile">
                    <ModalHeader 
                    className="modal-header"
                    style={{ border: "none" }}
                    toggle={handleDeclineModal_state}>Confirm Decline :</ModalHeader>
                    <ModalBody>
                    <div className="fare-modal-body">
                        <button onClick={()=>tripCancellation(bookingId)}>Decline</button>
                    </div>
                    </ModalBody>
                </Modal>
            </div>
        ):""
      }
      {
        (splitOption.value === "split")?(<div>
            <Modal isOpen={splitModal}>
                <ModalHeader 
                className="modal-header"
                style={{ border: "none" }}
                toggle={handlesplitModal}>
                    split Logic
                </ModalHeader>
                <ModalBody>
                    
                </ModalBody>
            </Modal>
        </div>):""
      }

      <section className="booking-main-input">
        <div className="inpBox-1">
          <input type="text" placeholder="Search by Id" 
          style={{height:"41px"}}
          value={statusPayload.id} onChange={(e)=>
          {
            setStatusPayload({...statusPayload,id:e.target.value})
            localStorage.setItem("bookingId",e.target.value)
          }} />           
           <ReactSelect
            isMulti={false}
            // value={customerName}
            value={localStorage.getItem("customerObj")?JSON.parse(localStorage.getItem("customerObj")):""}
            handleSelectedOption={getcustomerId}
            options={filterCusList}
            placeholder={"Search cus"}
            className="custom-select"
          />
          <ReactSelect
            isMulti={false}
          // value={driverName}
          value={localStorage.getItem("driverObj")?JSON.parse(localStorage.getItem("driverObj")):""}
          handleSelectedOption={getDriverName}
          options={filterDriverList}
          placeholder={"Search by Driver name.."}
          />
        
        </div>
        <div className="inpBox-2">
          <select name="" id=""
            style={{height:"41px"}}
            value={statusPayload.booking_type}
            onChange={(e)=>{
              const bookingType=e.target.value.trim()
              setStatusPayload((statusPayload)=>({...statusPayload,booking_type:bookingType}))
              localStorage.setItem("booking_type",bookingType)
            }}
          >
            <option value="">Choose Booking</option>
            <option value="GoodMove">GoodMove</option>
            <option value="ONDC">ONDC</option>
          </select>
          <select 
          style={{height:"41px"}}
          value={statusPayload.status} onChange={(e)=>{
            let  newstatus=e.target.value 
            setStatusPayload({...statusPayload,status:newstatus });
            localStorage.setItem("status",newstatus)
          }}>
            <option value="#" selected>
              Choose status
            </option>
            <option value="Accepted">Accepted</option>
            <option value="Canceled By Manager">Cancelled By Manager</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Pending">Pending</option>
          </select>
          <select 
          style={{height:"41px"}}
          value={statusPayload.booking_status} onChange={(e)=>{
            setStatusPayload({...statusPayload,booking_status:e.target.value  });
            localStorage.setItem("bookingStatus",e.target.value)
          }}>
            <option value="Choose booking status" selected>
              Choose booking status
            </option>
            <option value="Accepted">Accepted</option>
            <option value="Cancelled By Manager">Cancelled By Manager</option>
            <option value="Completed drop">Completed drop</option>
            <option value="Completed pickup">Completed Pickup</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Created">Created</option>
            <option value="Fare">Fare</option>
            <option value="Pending">Pending</option>
            <option value="Reached drop">Reached Drop</option>
            <option value="Reached pickup">Reached Pickup</option>
            <option value="Tour Completed">Tour Completed</option>
            <option value="Tour Created">Tour Created</option>
            <option value="Trip Created">Trip Created</option>
          </select>
        </div>
        <div className="booking-main-input-buttons">
          <button className="btn-big" onClick={filterByStatus}>Filter</button>
          <button className="btn-big" onClick={resetField}>Clear</button>
        </div>
      </section>


      {/* Delete Modal part ....... */}
      <section >
        <Modal isOpen={deleteModal} size="sm" className="delete-modal-mobile">
          <ModalHeader toggle={openDeleteModal}></ModalHeader>
          <ModalBody>
          <div id='deleteModalBody' >
                        <p>Are you sure you want to delete?</p>
                        <div className='confirm-cancel-button'>
                        <button onClick={deleteBooking}>Confirm</button>
                        <button onClick={()=>setDeleteModal(false)}>Cancel</button>
                        </div>
                    </div>
            
          </ModalBody>
        </Modal>
      </section>

      {/* Time & Fare & Waiting charges Modal */}
      <TimeEditModal
       editTime={editTime} handleChangeEditTime={handleChangeEditTime}  item={obj}
        initialFunction={getTodayBookings} params={statusPayload}/>
      <PaymentTypeEditModal 
        editPayment={editPayment} handleEditPayment={handleEditPayment} item={obj}
        initialFunction={getTodayBookings} params={statusPayload}
        />
      <FareEditModal
       editfare={editfare} handleEditFare={handleEditFare} item={obj}
        initialFunction={getTodayBookings} params={statusPayload}
        />
       <WaitingChargeEditModal 
        waitingCharges={waitingCharges} 
        handle_waitingCharges={handle_waitingCharges} item={obj}
        initialFunction={getTodayBookings} params={statusPayload}/>               

      <VegamEditModal isOpen={isVegamEdit} 
        initialFunction={getTodayBookings}
        handleVegam={handleVegam} item={obj}/>

        <DCEditModal dcNumber={dcNumber} handleDcNumber={handleDcNumber}  
        initialFunction={getTodayBookings} item={obj}/>

      {/* Table Section part ....... */}

      <section>
        
        <Table responsive  id="BookingTable">
          <thead >
            <tr style={{ borderBottom: "1px solid black", fontSize: "12px" }}>
              <th>EDIT</th>
              <th>DELETE</th>
              <th>NOTIFICATION</th>
              <th>ID</th>
              <th>TOUR ID</th>
              <th>TYPE</th>
              <th>BOOKING ACTION</th>
              <th>SPLIT / NO SPLIT</th>
              <th>CUSTOMER NAME</th>
              <th>COMPANY NAME</th>
              <th>PICKUP LOCATION</th>
              <th>PICKUP  TIME</th>
              <th>DROP OFF LOCATION</th>
              <th>DRIVER NAME</th>
              <th>REACHED PICKUP TIME</th>
              <th>PICKED UP GOODS TIME</th>
              <th>REACHED DROPOFF TIME</th>
              <th>GOODS DELIVERED TIME</th>
              <th>EDIT TIME</th>
              <th>WEIGHT <br /> (Kg/Cu.ft)</th>
              <th>CUSTOMER DC - NUM</th>
              <th>DRIVER   DC - NUM</th>
              <th>STATUS</th>
              <th>TOUR STATUS</th>
              <th>PAYMENT TYPE</th>
              <th>PAYMENT STATUS</th>
              <th>ESTIMATE FARE(Rs.)</th>
              <th>FARE COLLECTED(Rs.)</th>
              <th>WAITING CHARGE(Rs.)</th>
              <th>VIVEGAM</th>
              <th>ADDITIONAL INFO</th>
              <th>LOADING</th>
              <th>UNLOADING</th>
              <th>BOTH LOADING & UNLOADING</th>
            </tr>
          </thead>
         
           <tbody >            
            {
              loading ? (
                <tr>
                  <td colSpan={35}>
                      <div className="loading-spinner-container">
                  <div className="loading-spinner"></div>
                  <p style={{ fontSize: "16px" }}>Loading....</p> </div>
                  </td>
                </tr>
              ):bookData.length >0 ?
                  (bookData.filter((item)=>item.customer_name?.toLowerCase().includes(search.toLowerCase()) || 
                   (hasActiveDriverAssignment(item) && item.driver_name?.toLowerCase().includes(search.toLowerCase()))).map((item,index) => {
                    return (
                      <tr
                        key={index}
                        className={!item.booking_canceled_by_manager ? "":"lightGreyRow"}
                        style={{ borderBottom: "1px solid lightgrey" }}
                      >
                        <td 
                        className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ?
                        "lightGreyRow":""}
                        style={{ fontSize: "18px", cursor: "pointer"}}>
                          <BiEditAlt onClick={() => 
                            {
                              handleEdit(item)
                            // getAddressofCustomer(item.customer_id)
                            }
                            } /> 
                        </td>
                        <td
                        className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}
                          style={{ fontSize: "18px", cursor: "pointer" }}
                        >
                          <RiDeleteBin5Line size={19}
                                              className='deleteIcon'
                                              onClick={()=>openDeleteModal(item.id)}
                                              />
                          {/* <MdDeleteOutline /> */}
                          
                        </td>
                        {/* && item.booking_status !== "Tour Completed" */}
                        <td>{item.notification  ? ( 
                        <span onClick={()=>handleNotificationClose(item.id)} className="notification"> <IoMdClose size={18} className="notification_close"/> Delay at - {item.point} </span> ):("") }
                        {/* Waiting time! {item.waiting_time} */}
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.id}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.tour_id ? item.tour_id : "NA"}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""} >{item.booking_type}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          
                          {item.estimated_fare == 0 &&
                          item.fare === null &&
                          item.booking_confirm_status==0&&
                          !item.booking_canceled_by_manager
                          ? (
                            <div key={item.id} className="bookAction">
                              <select name="" id="" value={bookingAction} onChange={(event)=>handleBookingAction(event,item.id)}>
                                <option selected value="TBE">TBE</option>
                                <option value="Fare">Fare</option>
                                <option value="Decline">Decline</option>
                              </select>

                              <button
                                key={item.id}
                                // disabled={item.id==tripId }
                                // disabled={disable}
                                onClick={() => handletbeConfirmation(item.id)}
                              > Confirm</button>

                              {/* {item.booking_confirm_status && <button
                                key={item.id}
                                onClick={() => handletbeConfirmation(item.id)}
                              > Confirm</button>} */}
                              
                              
                            </div>
                          ) :
                        ( 
                          item.fare == null && item.estimated_fare != 0 && item.booking_canceled_by_manager == 0 &&
                          item.booking_confirm_status==0 &&
                          <div key={item.id} className="bookAction" >
                          <button
                        key={item.id}
                        // disabled={item.id==tripId2 }
                        onClick={() => handleConfirmation(item.id)}
                        // onClick={() => handletbeConfirmation(item.id)}
                      >
                        Confirm
                         </button>
                          <button
                              key={item.id}
                            // disabled={item.id==tripId }
                              // disabled={disable}
                              onClick={() => tripCancellation(item.id)}
                            >
                              Decline
                          </button>
                        </div>
                      ) }
                        </td>
                        
                        {/* Canceled By Customer */}
                        {/* className={!item.booking_canceled_by_manager ? "":"lightGreyRow"} */}
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                        {(!item.marked_as_trip && !item.booking_canceled_by_manager && !item.booking_canceled_by_customer)?<div className="split">
                            <select
                              name=""
                              id=""
                              value={splitOption.value}
                              
                              onChange={(event)=>handleSplitOption(event,item.id)}
                            >
                              <option selected value="no split">
                                No Split
                              </option>
                              <option value="split">Split</option>
                            </select>
                            <button
                              key={item.id}
                              onClick={() => handleSplitConfirmation(item,item.id,index)}
                              // disabled={index == indexNo}
                              // disabled={item.id==tripId }
                              // className="btn-small"
                            >
                              Confirm
                            </button>
                          </div>:""}
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.customer_name}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.company_name}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.pickup_location}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.pickup_time}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.dropoff_location}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          {
                            (item.id && item.tour_id )&& <FaMapMarkerAlt
                            className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""} 
                            style={{cursor:"pointer"}} size={23} color="#30A46C"
                            onClick={()=>navigate(`/dashboard/tours/bookings/${item.id}`)}/>
                          }
                           
                          {hasActiveDriverAssignment(item) ? item.driver_name : ""}
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.reached_pickup ? item.reached_pickup:""}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.completed_pickup?item.completed_pickup:""}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.reached_drop?item.reached_drop:""}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.completed_drop?item.completed_drop:""}</td>
                        <td 
                      className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}
                        style={{ fontSize: "18px", cursor: "pointer" }}>
                          <BiEditAlt onClick={()=>{
                              handleChangeEditTime()
                              getObj(item)
                          }} />
                          
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.commodity_weight} {item.weight_unit == 12 ? "Kg":"Cu.ft"}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          {item.dcNumber} {item.dcNumber && <BiEditAlt
                          onClick={()=>{
                            handleDcNumber()
                            getObj(item)
                          }} 
                          style={{ fontSize: "18px", cursor: "pointer" }}/>}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          {item.tdcNumber}{item.tdcNumber && <BiEditAlt
                          onClick={()=>{
                            handleDcNumber()
                            getObj(item)
                          }} 
                          style={{ fontSize: "18px", cursor: "pointer" }}/>}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.status}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.booking_status}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          {(item.is_regular === true && item.payment_status =="Pending") ? "TBE": item.payment_type}-{
                            item.payment_made_by === "other_party_pay" ?
                            (item.trip_type === "oneway" && item.booking_for === "pickup") ? (item.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                              (item.trip_type === "oneway" && item.booking_for === "drop") ? (item.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") :
                                (item.trip_type === "round" && item.booking_for === "pickup") ? (item.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                                  (item.trip_type === "round" && item.booking_for === "drop") ? (item.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") : "" :
                            item.payment_made_by === "pay_at_pickup" ? (item.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") :
                              item.payment_made_by === "pay_at_drop" ? (item.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                                item.payment_made_by === "ill_pay" ? (item.payment_status.toLowerCase() != "completed" ? "Customer choose to pay" : "Customer paid") : item.payment_made_by
                          }
                        </td>
                          
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                        <BiEditAlt
                            onClick={()=>{
                              handleEditPayment()
                              getObj(item)
                            }}
                            style={{ fontSize: "18px", cursor: "pointer" }}
                          /> 
                          {item.payment_status}
                        </td>
                        <td
                        className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}
                        style={{display:"flex"}}>
                        <BiEditAlt
                            onClick={()=>{
                              handleEditFare()
                              getObj(item)
                            }}
                            style={{ fontSize: "18px", cursor: "pointer" }}
                          />&nbsp;&nbsp;
                          {item.booking_type === "ONDC" && item.multi_booking_id ? item.estimated_fare :
                          (item.booking_type === null && item.multi_booking_id  ? item.total_booking_fare : item.fare)}
                        </td>&nbsp;&nbsp;
                        {/* <td>{item.multi_booking_id ? item.total_booking_fare: item.fare}</td> */}
                        {/* I changed to item.amount_collected to collection_amount */}
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                          {item.booking_type === "ONDC" && item.multi_booking_id ? item.requestInfo.collection_amount :
                          (item.booking_type === null && item.multi_booking_id  ? item.amount_collected : item.fare )}
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""} >
                        <BiEditAlt
                            onClick={()=>{
                              handle_waitingCharges()
                              getObj(item)
                            }}
                            size={18}
                            style={{ cursor: "pointer" }}
                          />&nbsp;&nbsp;
                          {item.waiting_charge}
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>
                              
                              <BiEditAlt
                              onClick={()=>{
                                handleVegam()
                                getObj(item)
                              }}
                                style={{ fontSize: "18px", cursor: "pointer" }}
                              />
                              {item.is_vivegam ? "Yes" : "No"}
                              
                        </td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.instruction}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.loading_charge_applicable ? "Yes":"No"}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.unloading_charge_applicable ? "Yes":"No"}</td>
                        <td className={item.booking_canceled_by_manager || item.booking_canceled_by_customer ? "lightGreyRow":""}>{item.both_loading_unloading_charge_applicable ? "Yes":"No"}</td>
                      </tr>
                    )}))   :
                    <tr>
                      <td colSpan={35}>
                        <p style={{textAlign:"center",color:"#30A46C"}}>No data Available...</p>
                      </td>
                    </tr>         
            }
          </tbody>
            
        </Table>
        
        {/* {(!bookData.length && !loading)&& <p style={{textAlign:"center",color:"#30A46C",fontSize:"15px"}}>No Records are Found..</p >} */}
      </section>

      <section id="paginationSection">
                {
            Boolean(bookData.length) &&
          <div className="paginationContainer">
                <div className="paginationBtnInput" >
                <Pagination
                      pageNumber={pageNumber}
                      handlePageChange={handlePageChange}
                      pageCount={pageCount}
                      />
                </div>

                <div className='paginationBtn'>
                  <input type="text"  onChange={handlePageNumber} placeholder="Page no.."/>
                  <button onClick={handleGoToPage}><FaArrowRight size={22}/></button>
                </div>
                <div className="pagination_select">
                  <div>Showing
                    </div>
                <select name="" id="" onChange={(e)=>setPageDataCount(parseInt(e.target.value))}>
                    {
                      result.map((elem,index)=><option key={index} value={elem}>{elem}</option>)
                    }
                  </select>
                  <div>Data per page</div>
                </div>

          </div>
          }
        
      </section>
    </div>
  );
};
const mapStateToProps = (state) => {   
  // console.log(state)
  
  };

export default Bookings;
